import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-bold text-secondary50 text-left" }, "Detalhes da validação", -1)
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-16"
}
const _hoisted_3 = { class: "w-24 h-24 rounded-full bg-[#eafbef] flex items-center justify-center mb-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-semibold text-[#16161d]" }, "Nenhum médico pendente de validação", -1)
const _hoisted_5 = {
  key: 1,
  class: "grid grid-cols-2 gap-6"
}
const _hoisted_6 = { class: "flex flex-col gap-5" }
const _hoisted_7 = { class: "text-left" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-base font-semibold text-[#16161d] mb-2" }, "Validação", -1)
const _hoisted_9 = { class: "flex flex-col gap-2" }
const _hoisted_10 = {
  class: "flex items-center gap-2 cursor-pointer",
  "data-testid": "approve-radio"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-base text-[#16161d]" }, "Aprovar", -1)
const _hoisted_12 = {
  class: "flex items-center gap-2 cursor-pointer",
  "data-testid": "reject-radio"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-base text-[#16161d]" }, "Reprovar", -1)
const _hoisted_14 = { class: "flex flex-col gap-1.5" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "text-[#da1e28]" }, "*", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-[#7f7f8e] text-left" }, "O motivo é registrado no histórico", -1)
const _hoisted_17 = {
  key: 0,
  class: "w-full"
}
const _hoisted_18 = {
  key: 1,
  class: "flex gap-4 w-full"
}
const _hoisted_19 = { class: "flex-1" }
const _hoisted_20 = { class: "flex-1" }

import { ref, computed, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { mdiCheckCircle, mdiArrowRight } from '@mdi/js'
import Modal from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import BiometryEvidencePanel from './BiometryEvidencePanel.vue'
import BiometryHistoryCard from './BiometryHistoryCard.vue'
import DoctorInfoCard from './DoctorInfoCard.vue'
import { useFacialBiometryStore } from '@/pinia-store/useFacialBiometryStore'
import { REJECTION_REASON_OPTIONS } from '@/constants/facial-biometry.constants'
import type { ValidateFacialBiometryPayload } from '@/types/facial-biometry.types'


export default /*#__PURE__*/_defineComponent({
  __name: 'ValidationDetailModal',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue", "validated"],
  setup(__props: any, { emit }) {





const store = useFacialBiometryStore()
const { currentDoctor, isLastStep, allValidated, isProcessing } = storeToRefs(store)

const validationChoice = ref<'VERIFIED' | 'REJECTED' | ''>('')
const selectedReason = ref('')
const customReason = ref('')
const rejectionOptions = REJECTION_REASON_OPTIONS

const canSubmit = computed(() => {
  if (!validationChoice.value) return false
  if (validationChoice.value === 'REJECTED') {
    if (!selectedReason.value) return false
    if (selectedReason.value === 'OTHER' && !customReason.value.trim()) return false
  }
  return true
})

watch(currentDoctor, () => {
  validationChoice.value = ''
  selectedReason.value = ''
  customReason.value = ''
})

async function handleNextValidation() {
  if (!currentDoctor.value?.id || !validationChoice.value) return

  const payload: ValidateFacialBiometryPayload = {
    status: validationChoice.value as 'VERIFIED' | 'REJECTED'
  }

  if (validationChoice.value === 'REJECTED') {
    payload.rejectionReason =
      selectedReason.value === 'OTHER' ? customReason.value.trim() : selectedReason.value
  }

  const success = await store.validateBiometry(currentDoctor.value.id, payload)
  if (success) {
    store.nextStep()
    emit('validated')
  }
}

function handleClose() {
  emit('update:modelValue', false)
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_textarea = _resolveComponent("v-textarea")!

  return (_openBlock(), _createBlock(Modal, {
    "modal-active": _ctx.modelValue,
    "max-width": "max-w-3xl",
    onClose: handleClose
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      (_unref(allValidated))
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createVNode(FilledButton, {
              "data-testid": "validation-close-final-button",
              text: "Fechar",
              width: "100%",
              height: "48px",
              onClick: handleClose
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createVNode(OutlineButton, {
                "data-testid": "validation-cancel-button",
                text: "Fechar",
                width: "100%",
                height: "48px",
                onClick: handleClose
              })
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(FilledButton, {
                "data-testid": "validation-next-button",
                text: _unref(isLastStep) ? 'Finalizar' : 'Próxima validação',
                width: "100%",
                height: "48px",
                disabled: !canSubmit.value || _unref(isProcessing),
                "prepend-icon": _unref(mdiArrowRight),
                onClick: handleNextValidation
              }, null, 8, ["text", "disabled", "prepend-icon"])
            ])
          ]))
    ]),
    default: _withCtx(() => [
      (_unref(allValidated))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_v_icon, {
                size: "56",
                color: "#198038"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(mdiCheckCircle)), 1)
                ]),
                _: 1
              })
            ]),
            _hoisted_4
          ]))
        : (_unref(currentDoctor))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(BiometryEvidencePanel, {
                "biometry-id": _unref(currentDoctor).id,
                "max-height-class": "max-h-[500px]"
              }, null, 8, ["biometry-id"]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(DoctorInfoCard, { doctor: _unref(currentDoctor) }, null, 8, ["doctor"]),
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("label", _hoisted_10, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((validationChoice).value = $event)),
                        type: "radio",
                        value: "VERIFIED",
                        "data-testid": "approve-radio-input",
                        class: "w-5 h-5 accent-[#2f7f91]"
                      }, null, 512), [
                        [_vModelRadio, validationChoice.value]
                      ]),
                      _hoisted_11
                    ]),
                    _createElementVNode("label", _hoisted_12, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((validationChoice).value = $event)),
                        type: "radio",
                        value: "REJECTED",
                        "data-testid": "reject-radio-input",
                        class: "w-5 h-5 accent-[#2f7f91]"
                      }, null, 512), [
                        [_vModelRadio, validationChoice.value]
                      ]),
                      _hoisted_13
                    ])
                  ])
                ]),
                (validationChoice.value === 'REJECTED')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_v_select, {
                          modelValue: selectedReason.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedReason).value = $event)),
                          items: _unref(rejectionOptions),
                          "data-testid": "rejection-reason-select",
                          variant: "outlined",
                          density: "comfortable",
                          "hide-details": "auto"
                        }, {
                          label: _withCtx(() => [
                            _createTextVNode(" Motivo da reprovação "),
                            _hoisted_15
                          ]),
                          _: 1
                        }, 8, ["modelValue", "items"]),
                        _hoisted_16
                      ]),
                      (selectedReason.value === 'OTHER')
                        ? (_openBlock(), _createBlock(_component_v_textarea, {
                            key: 0,
                            modelValue: customReason.value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((customReason).value = $event)),
                            "data-testid": "rejection-reason-textarea",
                            variant: "outlined",
                            density: "comfortable",
                            placeholder: "Digite o motivo da reprovação...",
                            "hide-details": "auto",
                            rows: "2"
                          }, null, 8, ["modelValue"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                _createVNode(BiometryHistoryCard, { doctor: _unref(currentDoctor) }, null, 8, ["doctor"])
              ])
            ]))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})